import { OtherBookBTA } from './otherBookBTA';
import { SeriesLink } from './seriesLink';
import { WhereAvailable } from '../types/where-available.interface';

export class FeaturedBook {
	created: any = null;

	updated: any = null;

	_id: string;

	_book = null;

	_owner: string = null;

	_promoCode: any = null;

	_pubDate: string = null;

	_site = null;

	_siteAdvert = null;

	_siteAdvertDay: string = null;

	_sitePost: string = null;

	ASIN: string = null;

	authorNotes: [{text: string; created: any}];

	awardsAccolades: string = null;

	bookPriceDuringPromo = 0;

	customAmazonTag = '';

	datePrepped = '';

	datePurchased = '';

	dealOfDay = false;

	description = '';

	editorial = false;

	emailOrder: number;

	freeEndDate: any = null;

	freeStartDate: any = null;

	hasMoved = false;

	kindleCountdownDeal = false;

	kindlePrice: number = null;

	kindleUnlimited = false;

	klaviyoAddedToCartCount = 0;

	klaviyoLive = false;

	klaviyoPurchased = false;

	notes = [];

	oldImportId: string = null;

	oldImportPromoCode = '';

	otherBooksBTA: OtherBookBTA[];

	paymentAmount = 0.00;

	paymentInfo: {
		payPalToken: {};
		stripeToken: {};
	};

	payPalTransactionID: string = null;

	paymentStatus = 'unpaid';

	permafree = false;

	postScheduled = false;

	pubDate: number = null;

	endPubDate: number = null;

	purchaserInfo = {
		email: '',
		firstName: '',
		lastName: '',
		memberRole: '',
		loggedIn: false,
	};

	referrer: string = null;

	reviewStatus = 'incomplete-payment';

	sentToMailchimp = false;

	seriesLinks: SeriesLink[];

	subscribeToList = true;

	_targetGenres: string[];

	primaryLink = '';

	whereAvailable: WhereAvailable = {
		apple: '',
		appleAudio: '',
		kobo: '',
		koboaudio: '',
		sony: '',
		nook: '',
		nookAudio: '',
		googleplay: '',
		googleplayAudio: '',
		hardcover: '',
		paperback: '',
		audiobook: '',
		authorstore: '',
		smashwords: '',
	};

	pricing = {
		apple: { discountPrice: '', price: '' },
		appleAudio: { discountPrice: '', price: '' },
		kobo: { discountPrice: '', price: '' },
		nook: { discountPrice: '', price: '' },
		nookAudio: { discountPrice: '', price: '' },
		sony: { discountPrice: '', price: '' },
		googleplay: { discountPrice: '', price: '' },
		googleplayAudio: { discountPrice: '', price: '' },
		hardcover: { discountPrice: '', price: '' },
		paperback: { discountPrice: '', price: '' },
		audiobook: { discountPrice: '', price: '' },
		scribd: { discountPrice: '', price: '' },
		audible: { discountPrice: '', price: '' },
		audiobookscom: { discountPrice: '', price: '' },
		koboaudio: { discountPrice: '', price: '' },
		kindle: { price: '' },
	};

	purchaseSource: string = null;

	orderPromoStackId: string = null;

	_order = null;
}
